export default __webpack_public_path__ + "static/media/bn-cocheseguro-feb2022.11e8e404.png";